module.exports = __webpack_public_path__ + "img/book.3027fe91.png";